<script setup>
import { ref, watchEffect, computed } from 'vue';
import axios from 'axios';
import * as bootstrap from 'bootstrap';
import { getFromAPI } from '../functionCollection';
import VueDatePicker from '@vuepic/vue-datepicker';

const props = defineProps(['saveUrl', 'getUrl']);

const newMedium = ref({
        identifier: '',
        Rechnungsempfaengernummer: '',
        Teilnehmer: '',
        nupsiNumber: '',
        type: 'rfid',
        bicycle_rate_id: '',
        charging_rate_id: '',
        was_used_until: '',
    });

const isEditMode = computed(() => props.getUrl !== '');
const submitResult = ref(null);
const submitError = ref(null);

const parseDate = (value) => {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? '' : date;
};

watchEffect(async () => {
    if (props.getUrl !== '') {
        const data = await getFromAPI(props.getUrl);
        if (data.was_used_until) {
            data.was_used_until = parseDate(data.was_used_until);
        }
        newMedium.value = data;
    }
})

    // adds the new medium. If succcessful, it shows a success modal which disappears after a 5s timer,
    // then reloads the page half a second later.
    async function addMedium() {
        submitError.value = null;
        submitResult.value = null;

        await axios.post(props.saveUrl, newMedium.value)
        .then(function (response) {
            submitResult.value = response;
            setTimeout(function() {
                const currentModal = document.querySelector('.modal.show');
                if (currentModal) {
                    const modal = bootstrap.Modal.getInstance(currentModal);
                    if (modal) {
                        modal.hide();
                    }
                }
            }, 5000);
            setTimeout(function() {
                window.location.reload();
            }, 5500);
        }).catch(function (error) {
            submitError.value = error;
        })

    }

</script>

<template>
    <form @submit.prevent="addMedium()">
        <div class="form-group">
            <label for="identifier">Zugangscode (Identifier) (*)</label>
            <input id="identifier"
                type="text"
                v-model="newMedium.identifier"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.identifier !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.identifier !== 'undefined')">
                {{ submitError.response.data.identifier[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="Rechnungsempfaengernummer">Rechnungsempfängernummer (*)</label>
            <input id="Rechnungsempfaengernummer"
                type="text"
                v-model="newMedium.Rechnungsempfaengernummer"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Rechnungsempfaengernummer !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Rechnungsempfaengernummer !== 'undefined')">
                {{ submitError.response.data.Rechnungsempfaengernummer[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="Teilnehmer">Teilnehmer</label>
            <input id="Teilnehmer"
                type="text"
                v-model="newMedium.Teilnehmer"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.Teilnehmer !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Teilnehmer !== 'undefined')">
                {{ submitError.response.data.Teilnehmer[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="nupsiNumber">Nupsi-Nr.</label>
            <input id="nupsiNumber"
                type="text"
                v-model="newMedium.nupsiNumber"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.nupsiNumber !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.nupsiNumber !== 'undefined')">
                {{ submitError.response.data.nupsiNumber[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="type">Typ (*)</label>
            <select
                v-model="newMedium.type"
                :class="{
                    'form-select form-control': true,
                    'form-select is-valid': (submitResult !== null),
                    'form-select is-invalid': (submitError !== null && typeof submitError.response.data.type !== 'undefined'),
                }"
            >
                <option selected value="rfid">RFID</option>
            </select>
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.type !== 'undefined')">
                {{ submitError.response.data.type[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="bicycle_rate_id">Fahrradtarif</label>
            <select
                v-model="newMedium.bicycle_rate_id"
                :class="{
                    'form-select form-control': true,
                    'form-select is-valid': (submitResult !== null),
                    'form-select is-invalid': (submitError !== null && typeof submitError.response.data.bicycle_rate_id !== 'undefined'),
                }"
            >
                <option selected value="1">Fahrrad abstellen</option>
            </select>
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.bicycle_rate_id !== 'undefined')">
                {{ submitError.response.data.bicycle_rate_id[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="charging_rate_id">Ladetarife</label>
            <select
                v-model="newMedium.charging_rate_id"
                :class="{
                    'form-select form-control': true,
                    'form-select is-valid': (submitResult !== null),
                    'form-select is-invalid': (submitError !== null && typeof submitError.response.data.charging_rate_id !== 'undefined'),
                }"
            >
                <option value="2">Mobility Key Aachen</option>
                <option value="7">Mobility Key Aachen Park-Flat</option>
                <option value="5">Mobility Key Berlin</option>
                <option value="3">Mobility Key Plus</option>
                <option value="4">Mobility Key Flat</option>
            </select>
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.charging_rate_id !== 'undefined')">
                {{ submitError.response.data.charging_rate_id[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="was_used_until">Ablaufdatum</label>
            <VueDatePicker
                v-model="newMedium.was_used_until"
                format="yyyy-MM-dd"
                placeholder="Ablaufdatum auswählen"
                input-class="form-control"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.was_used_until !== 'undefined')">
                {{ submitError.response.data.was_used_until[0] }}
            </div>
        </div>
        <p>Alle Felder mit (*) sind Pflichtfelder.</p>

        <button type="submit" class="btn btn-primary">{{ isEditMode ? 'Zugangsmedium bearbeiten' : 'Zugangsmedium erstellen' }}</button>
    </form>

    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Zugangsmedium erfolgreich angelegt.</span>
    </div>

    <div class="alert alert-danger" role="alert" v-if="submitError !== null && (submitError.response.status === 500 || submitError.response.status === 422)">
        {{ submitError.response.statusText }} <br>
        {{ submitError.response.data.message }}
    </div>


</template>
